export default "__VITE_ASSET__BXXKXyBI__"